module.exports = __webpack_public_path__ + "media/images/emblems/Broc-coat_of_arms-58110c3541d18bb8a98c14eebf1eab01.svg";